import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
    return (
        <div className="footer-container">
            <div className="footer-content">
                <div className="footer-nav">
                    <Link to="/">Home</Link>
                    <div className="footer-nav-divider"></div>
                    <Link to="chisiamo">Chi siamo</Link>
                    <div className="footer-nav-divider"></div>
                    <Link to="progetti">Progetti</Link>
                    <div className="footer-nav-divider"></div>
                    <Link to="foto">Foto</Link>
                    <div className="footer-nav-divider"></div>
                    <Link to="contatti">Contatti</Link>
                    <div className="footer-nav-divider"></div>
                    <Link to="donazioni">Donazioni</Link>
                </div>
                <div className="footer-legal-nav">
                    <Link to="privacy">Privacy Policy</Link>
                    <div className="footer-nav-divider"></div>
                    <Link to="cookie-policy">Cookie Policy</Link>
                    <div className="footer-nav-divider"></div>
                    <Link to="note-legali">Note Legali</Link>
                </div>
                <p>
                    Associazione Settemotivi ODV – Via De Paoli n. 19 – 33170 Pordenone (PN) – C.F. 91100000933 Tel. cell. +39 348 993 5038
                </p>
                <p>
                    
                    <a href="http://www.settemotivi.it" target="_blank" rel="noreferrer">www.settemotivi.it</a>
                    &nbsp;Mail:&nbsp;
                    <a href="mailto:segreteria@settemotivi.it">segreteria@settemotivi.it</a>
                    &nbsp;- Pec: <a href="mailto:settemotivi@pec.csvfvg.it">settemotivi@pec.csvfvg.it</a>
                </p>
                <p>
                    C/c bancario <strong>IT73 O 0835 664960 0000000 67146 – BCC Pordenone e Monsile – Agenzia di Prata di Pordenone</strong>
                </p>
                <p>
                    Iscritta RUNTS repertorio n. 56893 del 17/10/2022 (già n. 1367 del Registro delle O.d.V. Regione Friuli Venezia Giulia)
                </p>
            </div>
        </div>
    );
}

export default Footer;